import React from "react";
import { Link } from "react-router-dom";
import TestimonialHome from "../components/testimonialhhome";
import CTA from "../components/cta";
function Testimonial()
{
    return(
       <>
   <section
                       className="flat-title-page innerbanner mrg-0 boder-r-0 pdg-btm-60"
                       style={{ backgroundImage: "url(images/inner-banner/Testimonials.jpg)" }}
                     >
                       <div className="container">
                         <div className="breadcrumb-content">
                           <h1 className="text-center text-white title">Testimonials</h1>
                           <ul className="breadcrumb">
                             <li>
                               <Link to="/" className="text-white">
                                 Home
                               </Link>
                             </li>
                             <li className="text-white">/ About Us</li>
                             <li className="text-white">/ Testimonials</li>
                           </ul>
                         </div>
                       </div>
 </section> 
  <section className="flat-section flat-testimonial" style={{ paddingTop: 40 }}>
    <div className="container">
      <div className="box-title wow fadeInUp">
        <div
          className="wow fadeInUpSmall"
          data-wow-delay=".2s"
          data-wow-duration="2000ms"
        >
          <div className="text-subtitle text-primary">Our Testimonials</div>
          <h3 className="title mt-4">What our clients say about us</h3>
        </div>
      </div>
       <TestimonialHome />
    </div>
  </section>
  <CTA/>
</>

    )
}
    export default Testimonial;